require('./cardPINChangeStep.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @commmons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { formatCardNumber } = require('utilities/cardsHelper');

class CardPinChangeStep extends React.Component {
    buildInformation(immCard) {
        const contractNumber = immCard.get('fullContractNumber');
        const hiddenCardNumber = formatCardNumber(immCard.get('number'), 4, '*');
        const cardHolder = immCard.get('titularName');
        const cardType = immCard.getIn(['alias', 'current']);

        return (
            <section className="card-pin-change-step__list-section">
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title="cardPinChangeStep-cardPinChangeStep_contractNumber"
                        bodyText={contractNumber}
                    />
                    <OKInformativeListItem
                        title="cardPinChangeStep-cardPinChangeStep_cardNumber"
                        bodyText={hiddenCardNumber}
                    />
                    <OKInformativeListItem
                        title="cardPinChangeStep-cardPinChangeStep_cardHolder"
                        bodyText={cardHolder}
                    />
                    <OKInformativeListItem
                        title="cardPinChangeStep-cardPinChangeStep_cardType"
                        bodyText={cardType}
                    />
                </OKInformativeList>
            </section>
        );
    }

    render() {
        const { immCard, titleKey, children } = this.props;
        const list = this.buildInformation(immCard);
        const content = (
            <article className="card-pin-change-step">
                <header className="card-pin-change-step__title">
                    <FormattedText value={titleKey} />
                </header>
                {list}
                {children}
            </article>
        );

        return content;
    }
}

CardPinChangeStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    titleKey: PropTypes.string.isRequired,
    children: PropTypes.any
};

module.exports = CardPinChangeStep;
